import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';


import { alphabeticallySort,textContains } from '../../../shared/utils';
import moment from "moment";

class VerifiedPurchasesList extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading:false
    }
  }

  componentDidMount(){
      if(this.props.brandId) {
          return
      }
    this.setState({isLoading:true});

      const loadingPromises = [
          this.props.loadBrands(),
          this.props.loadReceiptLineups(),
          this.props.loadAgencies()
      ];
      // if (this.props.agencyId) {
      //     loadingPromises.push(this.props.loadCampaignsForAgency(this.props.agencyId, 0, 1000))
      // }

    Promise.all(loadingPromises)
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  render(){
    const { receiptLineups, updateReceiptLineup, loadReceiptLineups, brandId } = this.props;
    if (this.state.isLoading) {
        return <div>Loading...</div>
    }
    const archiveMenu = (id) => ({
          text:'Archive',
          confirmationText:'This is permanent and can not be reverted.',
          confirmationAcceptText:'Confirm',
          confirmationRejectText:'Cancel',
          onClick:() => {
              updateReceiptLineup(id, {archived: true})
                  .then(() => loadReceiptLineups())
          }
      })
    return (
        <div>
          <Row>
            <Col xs='12'>
              <SearchableDataTable
                  items={receiptLineups}
                  searchPromptText='Search by name'
                  emptyText='There are no verified purchases'
                  columns={[
                    {
                      display:`${brandId ? 'Product Name': 'Brand Name'}`,
                      name:'name',
                      width:20,
                      sortFunc:(a,b) => brandId ? alphabeticallySort(a.name,b.name) : alphabeticallySort(a.brand.name,b.brand.name),
                      filterFunc:(a,searchParam) => brandId ? textContains(a.name,searchParam) : textContains(a.brand.name,searchParam),
                      renderCell:(item) => (
                          <div>
                              {brandId ?
                                  <Link to={`${this.props.match.url}/${item.id}`}>{item.name}</Link>
                              :
                                  <Link to={`/superadmin/brands/${item.brandId}/edit`}>{item.brand.name}</Link>
                              }

                          </div>
                      )
                    },
                    {
                      name:'status',
                      width:12,
                      renderCell:(item) => (
                          <div>
                            <span>{item.status}</span>
                          </div>
                      )
                    },
                    {
                      name:'startDate',
                      display:'Start Date',
                      width:15,
                      sortFunc:(a,b) => a.startDate - b.startDate,
                      renderCell:(item) => <span>{moment(item.startDate).format('MMM D, YYYY')}</span>
                    },
                    {
                      name:'expirationDate',
                      display:'Expiration Date',
                      width:15,
                      sortFunc:(a,b) => a.expirationDate - b.expirationDate,
                      renderCell:(item) => <span>{moment(item.expirationDate).format('MMM D, YYYY')}</span>
                    },{
                          name:'budget',
                          width:10,
                          renderCell:(item) => (
                              <div>
                                  <span>{item.budget}</span>
                              </div>
                          )
                      },{
                          name:'pointsOffered',
                          display: 'Points Offered',
                          width:10,
                          renderCell:(item) => (
                              <div>
                                  <span>{item.receiptScanGroupList && item.receiptScanGroupList.length > 0 ? Math.floor(1000 * item.receiptScanGroupList[0].valuePerUser) : '' }</span>
                              </div>
                          )
                      },{
                          name:'priority',
                          width:10,
                          renderCell:(item) => (
                              <div>
                                  <span>{item.receiptScanGroupList && item.receiptScanGroupList.length > 0 ? item.receiptScanGroupList[0].priority : ''}</span>
                              </div>
                          )
                      },{
                          name:'scannedReceipts',
                          display:'Items Found',
                          width:10,
                          renderCell:(item) => (
                              <div>
                                  <span>{item.receiptScanGroupList && item.receiptScanGroupList.length > 0 ? item.receiptScanGroupList[0].count : '' }</span>
                              </div>
                          )
                      },{
                      width:20,
                      renderCell:(item) => (
                          <div className='pull-right'>
                              {item.brand.id &&
                              <Button
                                  size='sm'
                                  linkHref={`/superadmin/brands/${item.brandId}/verifiedpurchases/${item.id}`}
                                  textColor='#666666'
                                  borderColor='#cccccc'
                                  backgroundColor='#fff'
                              >
                                  Edit
                              </Button>
                              }
                              &nbsp;&nbsp;
                              <DropdownButton
                                  options={[archiveMenu(item.id)]}
                              />
                          </div>
                      )
                    }
                  ]}
              />
              <br />
              <br />
              <br />
            </Col>
          </Row>
        </div>
    )
  }
}

export default VerifiedPurchasesList;



// WEBPACK FOOTER //
// ./src/routes/VerifiedPurchasesList/components/VerifiedPurchasesList.js